// TableFilterSelectAllWrapper.js
import React from "react";

import { useTranslate } from "localization";

import TableFilterSelectAll from "./TableFilterSelectAll";

const TableFilterSelectAllWrapper = ({
  selectedRowIds,
  dataCount,
  totalDataCount,
  selectedAllRows,
  setSelectedRowIds,
  setSelectedAllRows,
}: {
  selectedRowIds: string[];
  dataCount: number;
  totalDataCount: number;
  selectedAllRows: boolean;
  setSelectedRowIds: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedAllRows: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { translate } = useTranslate();
  const selectedRowsCount = selectedRowIds.length;
  const currentPageSubmissionsCount = dataCount || -1;
  const isPartialSelection =
    selectedRowsCount > 0 && selectedRowsCount < currentPageSubmissionsCount;
  const isFullPageSelected = selectedRowsCount === currentPageSubmissionsCount;

  const handleClearSelection = () => {
    setSelectedRowIds([]);
    setSelectedAllRows(false);
  };

  const handleSelectAll = () => {
    setSelectedAllRows(true);
  };

  if (isPartialSelection) {
    return (
      <TableFilterSelectAll
        count={selectedRowsCount}
        actionText={translate("clearSelection")}
        onAction={handleClearSelection}
      />
    );
  }

  if (isFullPageSelected && !selectedAllRows) {
    return (
      <TableFilterSelectAll
        count={selectedRowsCount}
        actionText={translate("selectAll", { count: totalDataCount })}
        onAction={handleSelectAll}
      />
    );
  }

  if (isFullPageSelected && selectedAllRows) {
    return (
      <TableFilterSelectAll
        count={totalDataCount}
        actionText={translate("clearSelection")}
        onAction={handleClearSelection}
      />
    );
  }

  return null;
};

export default TableFilterSelectAllWrapper;
